var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoPinList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 40948"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 40947"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 16",
    d: "M1040.137 271.347h-3.181v3.181",
    transform: "translate(-1033.956 -269.347)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 17",
    d: "M3.181 0H0v3.181",
    transform: "rotate(90 9.5 11.5)",
    style: {
      strokeLinejoin: "round",
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 18",
    d: "M3.181 0H0v3.181",
    transform: "rotate(-90 12.107 9.107)",
    style: {
      strokeLinejoin: "round",
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 19",
    d: "M3.181 0H0v3.181",
    transform: "rotate(180 10.5 10.607)",
    style: {
      strokeLinejoin: "round",
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 40648"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13",
    d: "M1039.6 278.874v-2.386h11.638v2.386",
    transform: "translate(-1033.418 -269.282)",
    style: {
      strokeLinejoin: "round",
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 14",
    d: "M0 2.386V0h11.638v2.386",
    transform: "rotate(180 8.91 8.154)",
    style: {
      strokeLinejoin: "round",
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 15",
    d: "M1036.6 281.621h16.409",
    transform: "translate(-1032.804 -269.764)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: "1.5px"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPinList);
export default __webpack_public_path__ + "viewer/static/media/ico-pinList.bdf8f8c798bcd6d8caaaad0cccc46490.svg";
export { ForwardRef as ReactComponent };